import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { sendContactEmailRequest, resetContactStatus } from 'redux/actions/contactSettings.actions';
import useTypedSelector from 'hooks/useTypedSelector';
import { contactSettingsSelector } from 'redux/selectors/contactSettings.selector';
import ContactView from 'views/public/ContactView';
import LayoutContainer from 'containers/LayoutContainer';
import Loading from 'components/commons/Loading';
import i18next from 'i18next';
import 'views/public/ContactView/i18n';

const ContactContainer = () => {
  const dispatch = useDispatch();

  const { loading, success } = useTypedSelector(contactSettingsSelector);

  useEffect(() => {
    return () => {
      dispatch(resetContactStatus());
    };
  }, [dispatch]);

  const handleSendEmail = (subject: string, message: string) => {
    const formData = { subject, message };
    dispatch(sendContactEmailRequest(formData));
  };

  return (
    <LayoutContainer isPublic title={i18next.t<string>('PUBLIC_PROCEDURES_VIEW:TITLE')}>
      <ContactView onSendEmail={handleSendEmail} loading={loading} success={success} />
      {loading && <Loading isModalMode message={i18next.t('CONTACT:LOADING')} />}
    </LayoutContainer>
  );
};

export default ContactContainer;
